import React from "react";

// tslint:disable: max-line-length
interface Props {
  width?: number;
  height?: number;
  fill?: string;
}
export default function Fidelite(props: Props) {
  return (
    <svg
      id="gift"
      xmlns="http://www.w3.org/2000/svg"
      width={props.width ? props.width + "px" : "24px"}
      height={props.height ? props.height + "px" : "18px"}
      viewBox="0 0 32.232 32.232"
      fill={props.fill ? props.fill : "white"}
    >
      <path
        id="Tracé_7"
        data-name="Tracé 7"
        d="M26.846,28.116H4.015A2.017,2.017,0,0,1,2,26.1V12.672A.672.672,0,0,1,2.672,12H28.189a.672.672,0,0,1,.672.672V26.1A2.017,2.017,0,0,1,26.846,28.116ZM3.343,13.343V26.1a.673.673,0,0,0,.672.672H26.846a.673.673,0,0,0,.672-.672V13.343Z"
        transform="translate(0.686 4.116)"
      />
      <path
        id="Tracé_8"
        data-name="Tracé 8"
        d="M30.218,15.058H2.015A2.017,2.017,0,0,1,0,13.044V9.015A2.017,2.017,0,0,1,2.015,7h28.2a2.017,2.017,0,0,1,2.015,2.015v4.029A2.017,2.017,0,0,1,30.218,15.058ZM2.015,8.343a.673.673,0,0,0-.672.672v4.029a.673.673,0,0,0,.672.672h28.2a.673.673,0,0,0,.672-.672V9.015a.673.673,0,0,0-.672-.672Z"
        transform="translate(0 2.401)"
      />
      <path
        id="Tracé_9"
        data-name="Tracé 9"
        d="M12.172,10.744a.672.672,0,0,1-.665-.766C11.522,9.878,13.023,0,20.9,0c3.47,0,4.7,1.875,4.7,3.48,0,3.016-4.167,7.264-13.431,7.264Zm8.73-9.4c-5.522,0-7.405,5.889-7.909,8.045C20.35,9.159,24.26,5.874,24.26,3.48a1.747,1.747,0,0,0-.744-1.457,4.377,4.377,0,0,0-2.615-.68Z"
        transform="translate(3.944 0)"
      />
      <path
        id="Tracé_10"
        data-name="Tracé 10"
        d="M15.431,10.744C6.167,10.744,2,6.5,2,3.48A3.108,3.108,0,0,1,3.28.948,5.673,5.673,0,0,1,6.7,0c7.878,0,9.38,9.878,9.394,9.979a.672.672,0,0,1-.665.766ZM6.7,1.343c-2.072,0-3.359.818-3.359,2.137,0,2.4,3.912,5.681,11.275,5.909C14.13,7.22,12.294,1.343,6.7,1.343Z"
        transform="translate(0.686 0)"
      />
      <path
        id="Tracé_11"
        data-name="Tracé 11"
        d="M12.171,29.831a.672.672,0,0,1-.672-.671V7.672a.672.672,0,0,1,1.343,0V29.16A.672.672,0,0,1,12.171,29.831Z"
        transform="translate(3.945 2.401)"
      />
    </svg>
  );
}
